module.exports = __webpack_public_path__ + "static/a-higher-loyalty-c03875904488784074f55824259a728e.jpg";